export enum KnowledgeAndExperienceRedirectStepEnum {
  DoYouHaveExperience = 1,
  AverageNumberOfTrades,
  AverageVolumeOfTrades,
  TradingKnowledge,
  ChooseCorrectStatement,
}
